import React from "react";

const CONSENT_KEY = "cookie_consent";

const PrivacyPolicy = () => {
  const handleManageCookies = () => {
    localStorage.removeItem(CONSENT_KEY);
    window.location.reload();
  };

  return (
    <section className="section">
      <div className="container">

        <h1 className="text-10 fw-600 mb-5">
          Polityka Prywatności
        </h1>

        <p className="text-4">
          Niniejsza Polityka Prywatności określa zasady przetwarzania
          danych osobowych użytkowników korzystających ze strony
          internetowej Makosky Media oraz kontaktujących się za jej
          pośrednictwem.
        </p>

        <h2 className="text-6 fw-600 mt-4 mb-3">
          1. Administrator danych osobowych
        </h2>

        <p className="text-4">
          Administratorem danych osobowych jest Patryk Makowski,
          wykonujący działalność nierejestrowaną pod marką Makosky Media,
          zlokalizowaną w 83-200, Starogard Gdański.
        </p>

        <p className="text-4">
          Kontakt z administratorem możliwy jest poprzez:
          <br />
          E-mail:{" "}
          <a href="mailto:kontakt@makoskymedia.pl">
            kontakt@makoskymedia.pl
          </a>
          <br />
          Telefon: (+48) 451 460 682
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          2. Zakres i cel przetwarzania danych
        </h2>

        <p className="text-4">
          Dane osobowe przekazane za pomocą formularza kontaktowego,
          takie jak imię i nazwisko, adres e-mail, numer telefonu oraz
          treść wiadomości, przetwarzane są w celu:
        </p>

        <ul className="text-4">
          <li>
            udzielenia odpowiedzi na przesłane zapytanie,
          </li>
          <li>
            przygotowania oferty lub ustalenia szczegółów współpracy,
          </li>
          <li>
            prowadzenia korespondencji związanej z realizacją usług.
          </li>
        </ul>

        <p className="text-4">
          Podstawą prawną przetwarzania danych jest art. 6 ust. 1 lit.
          b oraz f Rozporządzenia Parlamentu Europejskiego i Rady (UE)
          2016/679 (RODO), czyli podjęcie działań na żądanie osoby,
          której dane dotyczą, przed zawarciem umowy oraz prawnie
          uzasadniony interes administratora polegający na prowadzeniu
          komunikacji z osobami zainteresowanymi usługami.
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          3. Okres przechowywania danych
        </h2>

        <p className="text-4">
          Dane osobowe przekazane za pomocą formularza kontaktowego
          przechowywane są przez okres niezbędny do udzielenia
          odpowiedzi oraz prowadzenia ewentualnej współpracy. Po
          zakończeniu kontaktu dane mogą być przechowywane przez czas
          wymagany przepisami prawa lub do momentu ustania uzasadnionego
          interesu administratora.
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          4. Odbiorcy danych
        </h2>

        <p className="text-4">
          Dane osobowe mogą być przekazywane podmiotom wspierającym
          działanie strony internetowej, w szczególności:
        </p>

        <ul className="text-4">
          <li>
            dostawcy hostingu strony internetowej,
          </li>
          <li>
            dostawcy usługi obsługi formularza kontaktowego (EmailJS),
          </li>
          <li>
            dostawcy narzędzia analitycznego Google Analytics (Google
            Ireland Limited / Google LLC) — wyłącznie za zgodą użytkownika,
            zgodnie z sekcją 7,
          </li>
          <li>
            innym podmiotom technicznym wyłącznie w zakresie niezbędnym
            do prawidłowego działania strony.
          </li>
        </ul>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          5. Prawa osób, których dane dotyczą
        </h2>

        <p className="text-4">
          Osobie, której dane dotyczą, przysługuje prawo do:
        </p>

        <ul className="text-4">
          <li>dostępu do swoich danych osobowych,</li>
          <li>sprostowania danych,</li>
          <li>usunięcia danych,</li>
          <li>ograniczenia przetwarzania danych,</li>
          <li>przenoszenia danych,</li>
          <li>wniesienia sprzeciwu wobec przetwarzania danych,</li>
          <li>
            cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność
            z prawem przetwarzania dokonanego przed jej cofnięciem
            (dotyczy danych przetwarzanych na podstawie zgody, w tym
            plików cookies opisanych w sekcji 7),
          </li>
          <li>
            wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych
            (ul. Stawki 2, 00-193 Warszawa), jeśli uzna, że przetwarzanie
            danych narusza przepisy RODO.
          </li>
        </ul>

        <p className="text-4">
          Administrator nie podejmuje wobec użytkowników zautomatyzowanych
          decyzji, w tym decyzji będących wynikiem profilowania, które
          wywoływałyby skutki prawne lub w podobny sposób istotnie
          wpływały na użytkownika.
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          6. Dobrowolność podania danych
        </h2>

        <p className="text-4">
          Podanie danych osobowych jest dobrowolne, jednak ich brak może
          uniemożliwić udzielenie odpowiedzi na przesłane zapytanie lub
          przygotowanie oferty.
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          7. Pliki cookies i Google Analytics
        </h2>

        <p className="text-4">
          Strona wykorzystuje pliki cookies niezbędne do jej
          prawidłowego działania (podstawa prawna: art. 6 ust. 1 lit. f
          RODO, prawnie uzasadniony interes administratora) oraz —
          wyłącznie za zgodą użytkownika — pliki cookies narzędzia
          Google Analytics dostarczanego przez Google Ireland Limited
          (podstawa prawna: art. 6 ust. 1 lit. a RODO, czyli zgoda).
        </p>

        <p className="text-4">
          W ramach Google Analytics przetwarzane mogą być następujące
          kategorie danych: adres IP (w formie zanonimizowanej),
          identyfikator urządzenia i przeglądarki, odwiedzane
          podstrony, czas spędzony na stronie, źródło wejścia na
          stronę oraz przybliżona lokalizacja (na poziomie miasta).
          Dane te są zbierane w formie zagregowanej i statystycznej
          i nie służą administratorowi do identyfikacji konkretnych
          osób.
        </p>

        <p className="text-4">
          Dane zbierane przez Google Analytics są przekazywane do
          Google LLC z siedzibą w USA. Przekazanie odbywa się w
          oparciu o standardowe klauzule umowne zatwierdzone przez
          Komisję Europejską, stanowiące mechanizm zapewniający
          odpowiedni poziom ochrony danych osobowych przy transferze
          poza Europejski Obszar Gospodarczy.
        </p>

        <p className="text-4">
          Dane zbierane przez Google Analytics przechowywane są przez
          okres do 14 miesięcy od ostatniej aktywności użytkownika, po
          czym są automatycznie usuwane.
        </p>

        <p className="text-4">
          Zgoda na pliki cookies Google Analytics jest wyrażana poprzez
          baner wyświetlany przy pierwszej wizycie na stronie. Użytkownik
          może w każdej chwili zmienić swoją decyzję, korzystając
          z przycisku poniżej, lub poprzez zmianę ustawień swojej
          przeglądarki internetowej.
        </p>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleManageCookies}
        >
          Zarządzaj ustawieniami cookies
        </button>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          8. Materiały multimedialne
        </h2>

        <p className="text-4">
          Strona może zawierać materiały multimedialne, takie jak filmy
          prezentowane za pomocą zewnętrznych platform hostingowych.
          Korzystanie z tych materiałów może wiązać się z przetwarzaniem
          danych przez dostawców tych usług zgodnie z ich własnymi
          zasadami prywatności.
        </p>


        <h2 className="text-6 fw-600 mt-4 mb-3">
          9. Zmiany Polityki Prywatności
        </h2>

        <p className="text-4">
          Administrator zastrzega sobie prawo do aktualizacji niniejszej
          Polityki Prywatności w przypadku zmian funkcjonowania strony,
          wykorzystywanych usług lub obowiązujących przepisów prawa.
        </p>

      </div>
    </section>
  );
};

export default PrivacyPolicy;